<template>
  <section>
    <el-alert
      class="notice"
      title="本应用由星云链驱动，请使用Chrome浏览器，并安装 钱包插件"
      type="warning" />
    <ul class="container">
      <li 
        @click="previewTask(task.id)"
        :key="task.id"
        class="task" 
        v-for="task in tasks">
        <img 
          class="task__cover"
          :src="task.cover">
        <div class="task__metas">
          <p class="task__title">{{ task.title }}</p>
          <span>发起人：{{ task.author }} (3/5)</span>
        </div> 
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  methods: {
    previewTask(taskId) {
      const task = this.tasks.find(({ id }) => id === taskId);
      this.$confirm(`挑战：${task.title} 创建人：${task.author}`, '挑战详情', {
        confirmButtonText: '参加',
        cancelButtonText: '返回' 
      }).then(() => {
        this.$message({ message: `您已加入 ${task.title} 挑战，不要忘记来打卡哦 ^_^`, type: 'success' });
      }).catch(() => { /* silently ignore */ });
    }
  },
  data() {
    return {
      tasks: [
        { id: 1, title: '早起打卡', cover: '//oiw32lugp.qnssl.com/cover-1.jpg', author: 'thb' },
        { id: 2, title: '早睡打卡', cover: '//oiw32lugp.qnssl.com/cover-2.jpg', author: 'xy' },
        { id: 3, title: '背英语', cover: '//oiw32lugp.qnssl.com/cover-3.jpg', author: 'sjn' }
      ]
    };
  }
}
</script>

<style scoped>
.notice {
  width: auto;
  margin: 0 30px;
  margin-bottom: 30px;
}

.container {
  padding: 0 30px;
  margin-bottom: 100px;
  list-style: none;
}

.task {
  background-color: #2C2251;
  border-bottom: 1px dashed #312B5B;
  margin-bottom: 30px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.task__metas {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: .9em;
  color: #ddd;
}

.task__cover {
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.task__title {
  margin: 0;
}
</style>
